module.exports = __webpack_public_path__ + "img/8c3e81c.png";